import { ActivatedRoute, Router } from "@angular/router";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "app/services";
import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { write } from "fs";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

import Typewriter from "t-writer.js";
import { Observable, Subscription } from "rxjs";
import { AppService } from "app/services/app.service";

@Component({
  selector: "app-new-join-offer-button",
  templateUrl: "./new-join-offer-button.component.html",
  styleUrls: ["./new-join-offer-button.component.scss"],
})
export class NewJoinOfferButtonComponent implements OnInit, OnDestroy {
  @ViewChild("modal") modal: any;
  modalRef: BsModalRef;

  public isLoading: boolean = false;
  public isScraping: boolean = false;
  public joinrsAiResponse: any = null;
  public linkValid: boolean = false;
  public errors: string[] = [];

  public link: string = "";

  public isDisabled: any = null;

  private _obs$: Subscription;

  constructor(
    private modalService: BsModalService,
    private commonService: CommonService,
    private toaster: ToasterService,
    private router: Router,
    private appService: AppService,
  ) { }

  ngOnInit() {
    this._reset();
    this._obs$ = this.appService
      .getJobStatus()
      .subscribe((r) => (this.isDisabled = r));
  }

  private _reset(): void {
    this.isLoading = false;
    this.isScraping = false;
    this.joinrsAiResponse = null;
    this.linkValid = false;
    this.errors = [];
  }

  ngOnDestroy(): void {
    this._obs$.unsubscribe();
  }

  openModal() {
    if (this.isDisabled && this.isDisabled.exceeded) {
      this.toaster.pop(
        "error",
        "Error",
        `Jobs active limit excedeed\nCurrent: ${this.isDisabled.current}\nMax: ${this.isDisabled.max}`
      );
      return;
    } else {
      this.router.navigate(["recruiting", "new"]);
    }
  }

  async joinrsAi() {
    this.isScraping = true;

    await new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, 3000);
    });

    try {
      this.commonService.jobFromUrl = {
        ...(await this.commonService.getJobFromUrl(this.link).toPromise()),
        _scraping_url: this.link,
      };
      this.modalRef.hide();
      this.router.navigate(["recruiting", "new"]);
    } catch (e) {
      this._reset();
      this.errors.push(
        `We were unable to extract the data from the inserted link but you can proceed manually and create a join offer by clicking on the button.`
      );
    }
  }

  async linkChange($event: any) {
    this.isLoading = true;

    try {
      const url = new URL($event.target.value);
      this.linkValid = true;
      this.isLoading = false;
    } catch (e) {
      this.linkValid = false;
      this.isLoading = false;
    }
  }
}
